// extracted by mini-css-extract-plugin
export default {"container":"ViewToggle_container__MmVVt","option":"ViewToggle_option__kyF5h","active":"ViewToggle_active__w1q2L"};